import { booleanAttribute, ChangeDetectionStrategy, Component, input, signal, ViewEncapsulation } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { BspkIcon } from '../icon';
import { BspkTxt } from '../txt';
import { BspkBadge } from '../badge';

@Component({
  selector: 'bspk-accordion',
  templateUrl: './accordion.component.html',
  styleUrl: './accordion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [BspkIcon, BspkTxt, BspkBadge],
  animations: [
    trigger('listAnimation', [
      state('collapsed', style({ height: '0', overflow: 'hidden', paddingTop: '0', paddingBottom: '0' })),
      state('expanded', style({ height: '*' })),
      transition('collapsed <=> expanded', animate('0.2s ease-in-out')),
    ]),
  ],
  host: {
    'data-bspk': 'accordion',
  },
})
export class BspkAccordion {
  readonly label = input.required<string>();
  readonly subtext = input<string>();
  readonly badgeCount = input<number>();
  readonly hideDivider = input(false, { transform: booleanAttribute });

  expanded = signal(true);

  toggleExpanded() {
    this.expanded.update((prev) => !prev);
  }
}
